function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52234",
  "data-name": "Path 52234",
  d: "M24,24H0V0H24Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "folder",
  transform: "translate(3.512 -37.679)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_67780",
  "data-name": "Group 67780",
  transform: "translate(0 44.506)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_67779",
  "data-name": "Group 67779",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52291",
  "data-name": "Path 52291",
  d: "M14.23,86.887H7.921L6.666,85.4a.214.214,0,0,0-.171-.077H1.4A1.414,1.414,0,0,0,0,86.733v9.174A1.414,1.414,0,0,0,1.413,97.32H14.23a1.414,1.414,0,0,0,1.413-1.413V88.3A1.414,1.414,0,0,0,14.23,86.887Z",
  transform: "translate(0 -85.319)",
  fill: "#7e84a3"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_67782",
  "data-name": "Group 67782",
  transform: "translate(1.86 42.679)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_67781",
  "data-name": "Group 67781",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52292",
  "data-name": "Path 52292",
  d: "M57.623,44.247H51.312l-1.255-1.492a.214.214,0,0,0-.171-.077H44.8A1.413,1.413,0,0,0,43.4,43.9h4.641a.821.821,0,0,1,.631.293l1.072,1.274H55.77a2.023,2.023,0,0,1,2.02,2.02v7.18a1.413,1.413,0,0,0,1.238-1.4V45.658A1.414,1.414,0,0,0,57.623,44.247Z",
  transform: "translate(-43.4 -42.679)",
  fill: "#7e84a3"
}))));

function SvgFilesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "filesIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesIcon);
export default __webpack_public_path__ + "static/media/filesIcon.a34c2ca5.svg";
export { ForwardRef as ReactComponent };